"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleInteriorColor = void 0;
const core_1 = require("@angular/core");
let VehicleInteriorColor = class VehicleInteriorColor {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleInteriorColor.prototype, "vehicle", void 0);
VehicleInteriorColor = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-interior-color',
        template: /* html */ `
    <span
      class="color-tag"
      [ngClass]="vehicle.vehicleData.features.interiorColor?.color"
    >
      <div class="vmin-tablet">
        {{ vehicle.vehicleData.features.interiorColor?.manufacturerCode || '' }}
      </div>

      <div class="color-circle interior-color" *ngIf="vehicle.vehicleData.features.interiorColor?.color" style="margin-right: 0.25rem"></div>

      <ng-template [ngIf]="vehicle.vehicleData.features.interiorColor" style="margin-left: 0.5rem">
        <svg class="ab-icon cell-icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          {{ vehicle.vehicleData.features.interiorColor?.manufacturerName || '' }} <br>
          <vehicle-interior-color-translation [color]="vehicle.vehicleData.features.interiorColor?.color"></vehicle-interior-color-translation><br>
          <vehicle-interior-type-translation [interior]="vehicle.vehicleData.features.interiorColor?.type"></vehicle-interior-type-translation>
        </div>
      </ng-template>
    </span>
  `,
    })
], VehicleInteriorColor);
exports.VehicleInteriorColor = VehicleInteriorColor;
